import { render, staticRenderFns } from "./HealthAndWellness.vue?vue&type=template&id=2c89a9fc&scoped=true&"
import script from "./HealthAndWellness.vue?vue&type=script&lang=js&"
export * from "./HealthAndWellness.vue?vue&type=script&lang=js&"
import style0 from "./HealthAndWellness.vue?vue&type=style&index=0&id=2c89a9fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c89a9fc",
  null
  
)

export default component.exports